export function getBoundingBox(
    centerLat: number,
    centerLng: number,
    zoom: number,
    screenWidthPx = 560,
    screenHeightPx = 800
  ) {
    const EARTH_RADIUS = 6378137;
    const DEG_TO_RAD = Math.PI / 180;
    const RAD_TO_DEG = 180 / Math.PI;

    const metersPerPixel =
      (156543.03392 * Math.cos(centerLat * DEG_TO_RAD)) / Math.pow(2, zoom);

    const halfWidthMeters = (screenWidthPx / 2) * metersPerPixel;
    const halfHeightMeters = (screenHeightPx / 2) * metersPerPixel;

    const deltaLat = (halfHeightMeters / EARTH_RADIUS) * RAD_TO_DEG;
    const deltaLng =
      (halfWidthMeters / (EARTH_RADIUS * Math.cos(centerLat * DEG_TO_RAD))) *
      RAD_TO_DEG;

    return {
      min_latitude: centerLat - deltaLat,
      max_latitude: centerLat + deltaLat,
      min_longitude: centerLng - deltaLng,
      max_longitude: centerLng + deltaLng,
    };
  }

export function getOffsetCenter(
  lat: number,
  lng: number,
  offsetX: number,
  offsetY: number,
  map: any
) {
  const projection = map.getProjection();
  const point = projection.fromCoordToPoint(new window.naver.maps.LatLng(lat, lng));
  const scale = Math.pow(2, map.getZoom());
  const worldCoordinateNewCenter = new window.naver.maps.Point(
    point.x - offsetX / scale,
    point.y - offsetY / scale
  );
  const newCenter = projection.fromPointToCoord(worldCoordinateNewCenter);
  
  return newCenter;
}
